import AgeRating from "@/models/AgeRating";

export default {
    state: {
        ageRating:  new AgeRating(),
        ageRatings: new Array(),
    },
    getters: {
        getAgeRating(state) {
            return state.ageRating;
        },
        getAgeRatings(state) {
            return state.ageRatings;
        },
    },
    mutations: {
        setAgeRating(state, dado) {
            state.ageRating = JSON.parse(JSON.stringify(dado ? dado : new AgeRating()));
        },
        setAgeRatings(state, dados) {
            state.ageRatings = dados;
        },
    },
    actions: {
        setAgeRating({ commit }, dado) {
            commit('setAgeRating', dado);
        },
        setAgeRatings({ commit }, dados) {
            commit('setAgeRatings', dados);
        },
    },
}
